const sha1 = require('sha1');

export const getHash = (obj: any) => {
  if(typeof obj !== 'string') {
    obj = JSON.stringify(obj)
  }

  return sha1(obj);
}
